// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__22pDt","itemTitle":"ClientEmergencyInfo_itemTitle__2-sw5","itemText":"ClientEmergencyInfo_itemText__3j954"};